import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('bau_token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) setUser(payload);
        else localStorage.removeItem('bau_token');
      } catch { localStorage.removeItem('bau_token'); }
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('bau_token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('bau_token');
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
